import _ from 'lodash'
import { UUID } from '@/plugins/common'
import Column from './column'

export default class Table {
  id
  name
  tableId
  columns = []
  isNew
  constructor (args) {
    if (args.columns) {
      args.columns.forEach(m => {
        this.columns.push(Column.load(m))
      })
    }
    _.defaults(this, args)
  }

  static load (args) {
    const table = new Table(args)
    table.isNew = false
    return table
  }

  static create (args) {
    args.tableId = args.id
    args.id = UUID.create()
    const table = new Table(args)
    table.isNew = true
    table.createColumn(UUID.create(), '标识', 'Identity')
    return table
  }

  // 加载归档列信息
  reload (args) {
    this.columns = []
    args.columns.forEach(m => {
      this.columns.push(Column.load(m))
    })
  }

  getColumn (columnId) {
    return this.columns.find(m => m.id === columnId)
  }

  getPrimaryKey () {
    return this.columns.find(m => m.name === '标识')
  }

  needCreateColumn ({ columnId, defaultArchivedId }) {
    return columnId === defaultArchivedId && !this.columns.some(m => m.id === columnId)
  }

  createColumn (id, name, dataType) {
    const column = Column.create({ id, name, dataType })

    this.columns.push(column)
    return column
  }

  removeColumn (column) {
    const pos = this.columns.indexOf(column)
    this.columns.splice(pos, 1)
  }
}



// WEBPACK FOOTER //
// ./src/store/form/table.js